import { render } from "./VideoView.vue?vue&type=template&id=3df5401f&scoped=true"
import script from "./VideoView.vue?vue&type=script&lang=js"
export * from "./VideoView.vue?vue&type=script&lang=js"

import "./VideoView.vue?vue&type=style&index=0&id=3df5401f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3df5401f"]])

export default __exports__